var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 12.5C25.5 19.4038 19.9038 25 13 25C6.09615 25 0.5 19.4038 0.5 12.5C0.5 5.59615 6.09615 0 13 0C13.3269 0 13.6731 0.0192096 14 0.0384404C20.0961 0.51921 24.9808 5.40387 25.4616 11.5C25.4808 11.8269 25.5 12.1731 25.5 12.5Z",
    fill: "#FFD600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0625 18.25C12.0625 18.25 11.125 18.25 11.125 17.3125C11.125 16.375 12.0625 13.5625 15.8125 13.5625C19.5625 13.5625 20.5 16.375 20.5 17.3125C20.5 18.25 19.5625 18.25 19.5625 18.25H12.0625ZM15.8125 12.625C16.5584 12.625 17.2738 12.3287 17.8012 11.8012C18.3287 11.2738 18.625 10.5584 18.625 9.8125C18.625 9.06658 18.3287 8.35121 17.8012 7.82376C17.2738 7.29632 16.5584 7 15.8125 7C15.0666 7 14.3512 7.29632 13.8238 7.82376C13.2963 8.35121 13 9.06658 13 9.8125C13 10.5584 13.2963 11.2738 13.8238 11.8012C14.3512 12.3287 15.0666 12.625 15.8125 12.625Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.39 18.2504C10.251 17.9577 10.1817 17.6368 10.1875 17.3129C10.1875 16.0426 10.825 14.7348 12.0025 13.8254C11.4148 13.6443 10.8025 13.5558 10.1875 13.5629C6.4375 13.5629 5.5 16.3754 5.5 17.3129C5.5 18.2504 6.4375 18.2504 6.4375 18.2504H10.39Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.71875 12.625C10.3404 12.625 10.9365 12.3781 11.376 11.9385C11.8156 11.499 12.0625 10.9029 12.0625 10.2812C12.0625 9.65965 11.8156 9.06351 11.376 8.62397C10.9365 8.18443 10.3404 7.9375 9.71875 7.9375C9.09715 7.9375 8.50101 8.18443 8.06147 8.62397C7.62193 9.06351 7.375 9.65965 7.375 10.2812C7.375 10.9029 7.62193 11.499 8.06147 11.9385C8.50101 12.3781 9.09715 12.625 9.71875 12.625Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.40d0d85213119186ffd8b81942c39700.svg";
export { ForwardRef as ReactComponent };